import { useQueryHelper } from '@anytag/shared-hooks';
import { ProposeInfluencersTableModes, usePackageProposalContext } from '@anytag/shared-organisms';
import {
  namedOperations,
  ProposalJobDescriptionBreakDownMode,
  useUpdatePackageProposalModeMutation
} from '@anytag/graphql';

interface ToggleJdModeAndBudgetEditProps {
  onShowConfirmModal: () => void;
}
export const ToggleJdModeAndBudgetEdit = ({ onShowConfirmModal }: ToggleJdModeAndBudgetEditProps) => {
  const { enqueueSnackbar } = useQueryHelper();
  const { callUpdatePackageProposalMode } = useUpdatePackageProposalModeMutation({
    refetchQueries: [namedOperations.Query.PackageProposal, namedOperations.Query.PackageProposalSummary]
  });
  const { proposalSummary } = usePackageProposalContext();

  const jdMode = proposalSummary?.jdMode || ProposalJobDescriptionBreakDownMode.SOCIAL_BREAKDOWN;

  const handleJdModeChange = async (mode: ProposalJobDescriptionBreakDownMode) => {
    if (proposalSummary) {
      try {
        await callUpdatePackageProposalMode({
          variables: { input: { jdMode: mode, packageId: proposalSummary.id } }
        });
      } catch (error) {
        enqueueSnackbar(error.message, { variant: 'error' });
      }
    }
  };

  return (
    <ProposeInfluencersTableModes
      jdMode={jdMode}
      onEditJdMode={handleJdModeChange}
      onShowConfirmModal={onShowConfirmModal}
    />
  );
};
